export default [
  {
    name: 'Checklist.Report',
    path: 'report',
    component: () => import('./components/report/Report')
  },
  {
    name: 'Checklist.Report.User',
    path: 'report/:sessionId',
    props: true,
    component: () => import('./components/report/User')
  }
]
